import React, {useState} from "react";
import BaseSearch from "../BaseSearch";

function ListSearch( {filterItem, onChange, labelFunc, defaultSelected = []} ) {
    const [result, setResult] = useState([]);
    
    const attributes = {
        labelKey: item => labelFunc ? labelFunc(item) : item['name'],
        defaultSelected: defaultSelected,
        options: result || [],
        onSearchAttr: query => setResult(filterItem(query)),
        onChangeAttr: onChange,
        clearButton: false,
        className: 'form-group search-group search-group-button px-0 pb-0'
    }

    return <BaseSearch attributes={attributes}/>
}

export default ListSearch;